import { getDataIdsFromContract } from '../../utils/dataId';

export const ENTITY_DISPLAY_DETAILS_DATA_IDS = getDataIdsFromContract({
  base: 'entity-display-details',
  title: 'title',
  edit: 'edit',
  itemDisplay: 'display',
  itemValue: 'value',
  itemHelp: 'help'
});
